import * as S from '../DetailCardLoader/DetailCardLoader.styles';

export const RightWidgetLoader = () => (
  <S.SignUpOuterWrapDiv>
    <S.SignUpOuterFirstWrapDiv>
      <S.SignUpOuterFirstWrapimageDiv></S.SignUpOuterFirstWrapimageDiv>
      <S.SignUpOuterFirstWraptextDiv>
        <S.SignUpOuterFirstWrapInnerDiv />
        <S.SignUpOuterSecondWrapInnerDiv />
      </S.SignUpOuterFirstWraptextDiv>
    </S.SignUpOuterFirstWrapDiv>
    <S.SignUpOuterSecondWrapDiv>
      <S.GiftCardWrapDiv />
      <S.GiftCardWrapDiv />
    </S.SignUpOuterSecondWrapDiv>
    <S.SignUpOuterThirdWrapDiv>
      <S.PricingTextWrapDiv>
        <S.PricingTextLeftWrapDiv>
          <S.PricingTextLeftOneWrapDiv />
          <S.PricingTextLeftOneWrapDiv />
          <S.PricingTextLeftSecondWrapDiv />
        </S.PricingTextLeftWrapDiv>
        <S.PricingTextRightWrapDiv>
          <S.PricingTextRightTextWrapDiv />
          <S.PricingTextRightTextWrapDiv />
        </S.PricingTextRightWrapDiv>
      </S.PricingTextWrapDiv>
      <S.PayAmountWrapDiv>
        <S.PayAmountWrapInnerDiv />
      </S.PayAmountWrapDiv>
    </S.SignUpOuterThirdWrapDiv>
  </S.SignUpOuterWrapDiv>
);

export const DetailCardLoader = () => (
  <S.DetailCardLoaderWrapDiv>
    <S.DetailCardLoaderGalleryBlock>
      <S.HotelGalleryBlockDiv />
      {/* <S.TravellerGalleryBlockDiv>
        <S.TravellerGalleryInnerDiv></S.TravellerGalleryInnerDiv>
        <S.TravellerGalleryInnerDiv></S.TravellerGalleryInnerDiv>
        <S.ReviewRightComponentInnerWrapDiv>
          <S.GuestLikeHeaderWrapDiv>
            <S.GuestLikeLoaderDiv />
          </S.GuestLikeHeaderWrapDiv>
          <S.AmmenitiesTypeOuterDiv>
            <S.AmmenitiesTypeNewDiv />
            <S.AmmenitiesTypeNewDiv />
          </S.AmmenitiesTypeOuterDiv>
        </S.ReviewRightComponentInnerWrapDiv>
      </S.TravellerGalleryBlockDiv> */}
    </S.DetailCardLoaderGalleryBlock>

    <S.DetailCardLoaderPricingBlock>
      <S.GuestLikeOuterWrapDiv>
        <S.GuestLikeInnerWrapDiv>
          <S.GuestLikeHeaderLoaderWrapDiv>
            <S.GuestLikeHeaderLoaderSpan />
          </S.GuestLikeHeaderLoaderWrapDiv>
          <S.GuestLikeHeaderLoaderWrapDiv>
            <S.GuestLikeHeaderLoaderOneSpan />
            <S.GuestLikeHeaderLoaderTwoSpan />
            <S.GuestLikeHeaderLoaderTwoSpan />
          </S.GuestLikeHeaderLoaderWrapDiv>
          <S.GuestLikeHeaderLoaderWrapDiv>
            <S.GuestLikeHeaderLoaderSpan />
          </S.GuestLikeHeaderLoaderWrapDiv>
          <S.GuestLikeHeaderLoaderWrapDiv>
            <S.GuestLikeHeaderLoaderOneSpan />
            <S.GuestLikeHeaderLoaderTwoSpan />
            <S.GuestLikeHeaderLoaderTwoSpan />
          </S.GuestLikeHeaderLoaderWrapDiv>
        </S.GuestLikeInnerWrapDiv>
      </S.GuestLikeOuterWrapDiv>
      <RightWidgetLoader />
    </S.DetailCardLoaderPricingBlock>
  </S.DetailCardLoaderWrapDiv>
);
